import { useEffect } from "react";

import {DeliveryMethod, OrderFields, ParcelWeight} from "../../constants";
import useOrderFormik from "../useOrderFormik";
import useOrderData from "../../context/useOrderData";

const fieldName = OrderFields.PACKAGE_WEIGHT;
const packageSizeFieldName = OrderFields.PACKAGE_SIZE;
const destinationCountryFieldName = OrderFields.DESTINATION_COUNTRY;
const weightRegulationsFieldName = OrderFields.WEIGHT_REGULATIONS;
const deliveryMethodFieldName = OrderFields.DELIVERY_METHOD;

const useDefaultParcelWeight = (): void => {
    const {
        values: {
            [fieldName]: currentValue,
            [packageSizeFieldName]: packageSize,
            [weightRegulationsFieldName]: weightRegulations,
            [destinationCountryFieldName]: destinationCountry,
            [deliveryMethodFieldName]: deliveryMethod
        },
        setFieldValue,
        setFieldError,
    } = useOrderFormik();

    const {
        staticData: { parcelWeights },
    } = useOrderData();

    const parcelWeightMandatory = weightRegulations?.includes(destinationCountry?.toLowerCase() || '');

    const packageWeights = [
        {
            value: ParcelWeight.S1,
            isDisabled: !parcelWeightMandatory ||
                (!['XS', 'S', 'M', 'L'].includes(packageSize || '') &&
                    (deliveryMethod ? [DeliveryMethod.PudoToPudo, DeliveryMethod.DoorToPudo].includes(deliveryMethod) : false))
        },
        {
            value: ParcelWeight.S2,
            isDisabled: !parcelWeightMandatory ||
                (!['XS', 'S', 'M', 'L'].includes(packageSize || '') &&
                    (deliveryMethod ? [DeliveryMethod.PudoToPudo, DeliveryMethod.DoorToPudo].includes(deliveryMethod) : false))
        },
        {
            value: ParcelWeight.S3,
            isDisabled: !parcelWeightMandatory ||
                (['XS', 'S', 'M', 'L'].includes(packageSize || '') &&
                    (deliveryMethod ? [DeliveryMethod.PudoToPudo, DeliveryMethod.DoorToPudo].includes(deliveryMethod) : false))
        }
    ];

    const updatedParcelWeights = parcelWeights.map((item, index) => ({
        ...item,
        isDisabled: packageWeights[index].isDisabled,
    }));

    const defaultPackageWeightValue = updatedParcelWeights.filter(({ isDisabled }) => !isDisabled)[0]?.value;

    useEffect(() => {
        if (currentValue && updatedParcelWeights.filter(({ isDisabled }) => isDisabled).find(({ value }) => value === currentValue) && setFieldValue) {
            setFieldValue(fieldName, defaultPackageWeightValue || null);
            setFieldError(fieldName, undefined);
        }
    }, [currentValue, defaultPackageWeightValue, updatedParcelWeights, setFieldError, setFieldValue]);
};
export default useDefaultParcelWeight;
